<template>
  <el-select
    v-model="selected"
    v-loadmore="getModelList"
    :trigger-on-focus="false"
    remote
    :remote-method="remoteMethod"
    :loading="remoteLoading"
    :filterable="hasAll ? false : true"
    :value-key="valueKey"
    :multiple="multiple"
    :collapse-tags="multiple"
    v-bind="$attrs"
    v-on="$listeners"
    @clear="onClear"
    @visible-change="visibleChange"
  >
    <el-option
      v-for="(item) in modelList"
      :key="valueKey ? item : item[config.value]"
      :label="valueKey ? item : label ? item[label] : item[config.label]"
      :value="valueKey ? item : value ? item[value] : item[config.value]"
    >
    </el-option>
  </el-select>
</template>
<script>
/**
 * 通用下拉组件(查询接口数据)
 * author: 苏金铃
 */
import { getApiConfig } from '@/api/select/config.js';
import {isFunction} from "@/utils/validate";

export default {
  name: 'BjSelectRemote',
  model: {
    prop: 'data',
    event: 'onDataChange'
  },
  props: {
    data: {
      type: [String, Number, Array, Object],
      default: () => ''
    },
    // 接口name 必填项
    type: {
      type: String,
      default: () => ''
    },
    // 绑定值为对象类型时必填
    valueKey: {
      type: [String],
      default: () => ''
    },
    // 显示内容
    label: {
      type: [String, Number, Boolean],
      default: () => ''
    },
    // 绑定值
    value: {
      type: [String],
      default: () => ''
    },
    // 查询参数key
    queryKey: {
      type: [String],
      default: () => ''
    },
    // 接口所需额外参数
    params: {
      type: [Object],
      default: () => {}
    },
    // 是否多选
    multiple: {
      type: [Boolean],
      default: () => false
    },
    // 是否添加全部, 值为true，远程搜索不可用
    hasAll: {
      type: Boolean,
      default: () => false
    },
    // 特殊的分页数据（从0开始）
    pageNumber: {
      type: [String, Number],
      default: () => ''
    },
    // 指定查询内容
    queryValue: {
      type: [String],
      default: () => ''
    }
  },
  data() {
    return {
      selected: '',
      modelList: [],
      pagination: {
        pageNumber: 1,
        pageSize: 10,
        total: 0
      },
      query: '',
      remoteLoading: false
    };
  },
  computed: {
    // 接口配置
    config() {
      return getApiConfig(this.type);
    },
    // 查询参数
    queryName() {
      // this.config.label 显示内容，一般也作为查询参数
       const { queryKey, label } = this.config;
      return this.queryKey ? this.queryKey : queryKey ? queryKey : label;
    },
    pageIndexKey(){
      const { pageIndexKey } = this.config;
      return pageIndexKey || 'pageNumber';
    },
    request() {
      const {method = 'get', transformResult } = this.config;
      if (isFunction(method)) {
        return (url, params) => {
          return method({url, params, data: params, transformResult})
        }
      } else {
        return method === 'post' ? this.$post : this.$get
      }
    }
  },
  watch: {
    selected: {
      handler(selected) {
        this.$emit('onDataChange', selected);
      }
    },
    data: {
      immediate: true,
      handler(data) {
        this.selected = data;
      }
    },
    // 指定查询内容
    queryValue: {
      handler(value) {
       if(value) this.remoteMethod(value);
      }
    }
  },
  created() {
    this.remoteMethod();
  },
  methods: {
    async remoteMethod(query = '') {
      // 输入查询
      this.remoteLoading = true;
      this.query = query;
      this.pagination = {
        ...this.pagination,
        pageNumber: this.pageNumber === 0 ? this.pageNumber : 1
      };
      const { pageNumber, pageSize } = this.pagination;
      const params = {
        [this.queryName]: query,
        [this.pageIndexKey]: pageNumber,
        pageSize,
        ...this.params
      };
      const { data } = await this.request(this.config.url, params);
      const list = data.list || data.content || data.dataList || data || [];
      // 是否需要添加全部
      this.modelList = this.hasAll ? [{ [this.config.value]: '', [this.label || this.config.label]: '全部' }, ...list] : list;
      if (data.totalElements || data.page.totalCount) {
        this.pagination.total = data.totalElements || data.page.totalCount;
        this.pagination.pageNumber += 1;
      }
      this.remoteLoading = false;


    },
    // 下拉分页加载
    async getModelList() {
      const { pageNumber, pageSize, total } = this.pagination;
      if (((pageNumber - 1) * pageSize > total) || !total) {
        return;
      }
      this.remoteLoading = true;
      const params = {
        [this.queryName]: this.query,
         [this.pageIndexKey]: pageNumber,
        pageSize,
        ...this.params
      };
      const { data } = await this.request(this.config.url, params);
      const modelList = data.list || data.content || data.dataList || data || [];
      this.modelList = [...this.modelList, ...modelList];
      this.pagination.total = data.totalElements || data.page.totalCount;
      this.pagination.pageNumber += 1;
      this.remoteLoading = false;
    },
    // 点击清空按钮时触发
    onClear() {
      this.remoteMethod();
    },
    /**
     * 下拉框出现/隐藏时触发
     * @visible 出现则为 true，隐藏则为 false
     */
    visibleChange(visible) {
      if (!visible && !this.selected) {
        this.remoteMethod();
      }
    }
  }
};
</script>

